const paymentTypesForSelection = ['Incoming', 'Outgoing', 'Funding', 'Withdrawal', 'Refund'].map(key => {
	return { id: key, name: key };
});
const paymentStatusForSelection = [
	'Created',
	'Confirmed',
	'Approved',
	'Completed',
	'Cancelled',
	'Expired',
	'Failed',
	'Declined'
].map(key => {
	return { id: key, name: key };
});
export { paymentStatusForSelection, paymentTypesForSelection };
